import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FhAlertComponent } from './components/fh-alert.component';
import { FhTextModule } from '@fh-client-interaction-frontends/fh-text';

@NgModule({
  imports: [CommonModule, FhTextModule],
  declarations: [FhAlertComponent],
  exports: [FhAlertComponent]
})
export class FhAlertModule {}
